module.exports = __webpack_public_path__ + "9f728285559a5220ce7c59727002aca5.svg";